import styled from 'styled-components';
import {Button} from 'antd';
import {typographyStyles} from '../../../utils/styles';

const StyledListShowMoreWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const StyledListShowMoreWrapperButton = styled(Button)`
  margin: auto;
  width: max-content;

  &.ant-btn-variant-link {
    ${typographyStyles.footnote.description};
    color: ${props => props.theme.colors.primary_6};
  }
`;

export {
  StyledListShowMoreWrapper,
  StyledListShowMoreWrapperButton,
}

